import "./index.css";

export const TabDependentCard = ({ accountingPeriod, activeIndex }) => {
  return (
    <div
      className="epr-paragraph-box"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {activeIndex === 1 ? (
        <>
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
            Here you will run through your account plan.
          </p>
          <p>
            We are interested in your purchases and where your receipts are
            kept.
          </p>
          <div className="accounting-period-box">
            <p style={{ color: "white", marginBottom: 0 }}>
              {accountingPeriod}
            </p>
          </div>
        </>
      ) : (
        <>
          <p>
            <b>
              In this section we are placing the invoices in the right
              categories toward the emissions.{" "}
            </b>
            You need to direct the invoices to the relevant category. You can
            even remove an individual entry eg. if it was a corrected related to
            last year or the like, by opening the account line to show
            individual entries in the left column. In the right section your
            entries have been automatically loaded in the first three columns.
            Please place them in the right category by using the guide below in
            the last two columns - first being category - next being relevant
            emission factor.
          </p>
        </>
      )}
    </div>
  );
};
